export const importContactsCopy = {
  header: '',
  description: '',
  confirmBtnText: '',
  fileSelect: '',
  warning: '',
  successToast: '',
  successToastSingular: '',
};
